import script from "./period-selection-item.vue?vue&type=script&lang=ts&setup=true"
export * from "./period-selection-item.vue?vue&type=script&lang=ts&setup=true"

import "./period-selection-item.vue?vue&type=style&index=0&id=0bbd3218&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bbd3218"]])

export default __exports__